"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Rating = Rating;
exports.RatingValue = void 0;

var React = _interopRequireWildcard(require("react"));

var _ratingSvgPaths = require("./ratingSvgPaths");

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var RatingValue;
exports.RatingValue = RatingValue;

(function (RatingValue) {
  RatingValue[RatingValue["ZERO"] = 0] = "ZERO";
  RatingValue[RatingValue["ZERO_FIVE"] = 0.5] = "ZERO_FIVE";
  RatingValue[RatingValue["ONE"] = 1] = "ONE";
  RatingValue[RatingValue["ONE_FIVE"] = 1.5] = "ONE_FIVE";
  RatingValue[RatingValue["TWO"] = 2] = "TWO";
  RatingValue[RatingValue["TWO_FIVE"] = 2.5] = "TWO_FIVE";
  RatingValue[RatingValue["THREE"] = 3] = "THREE";
  RatingValue[RatingValue["THREE_FIVE"] = 3.5] = "THREE_FIVE";
  RatingValue[RatingValue["FOUR"] = 4] = "FOUR";
  RatingValue[RatingValue["FOUR_FIVE"] = 4.5] = "FOUR_FIVE";
  RatingValue[RatingValue["FIVE"] = 5] = "FIVE";
})(RatingValue || (exports.RatingValue = RatingValue = {}));

function Rating(_ref) {
  var rating = _ref.rating;
  return /*#__PURE__*/React.createElement("svg", {
    width: "80px",
    height: "16px",
    viewBox: "0 0 80 16",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, _ratingSvgPaths.ratingSvgPaths[rating]);
}